module.exports = __webpack_public_path__ + "assets/img/11_998.655cbd16.jpg";